import { useWideLayout } from '@shared/hooks';
import { Container } from 'react-bootstrap';
import React from 'react';

const MainLayoutContainer = ({ children }) => {
  const { isTVLayout, isWEBLayout } = useWideLayout();

  const containerClassname = isTVLayout
    ? 'container-lg main-layout-tv-container'
    : isWEBLayout
    ? 'layout-web-container'
    : 'container-sm';

  return <Container className={containerClassname}>{children}</Container>;
};

export { MainLayoutContainer };
